import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { createVuetify } from 'vuetify';
import 'vuetify/styles'
import './styles/theme.css'
import '@mdi/font/css/materialdesignicons.css'
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import Axios from 'axios';
import { User } from "@/store/auth.module";
import VueCookies from 'vue3-cookies';

console.log(`
 _   _             __   _   _        __ 
| | (_)           / _| | | (_)      / _|
| |_ _  ___   ___| |_  | |_ _  __ _| |_ 
| __| |/ _ \\ / _ \\  _| | __| |/ _' |  _|
| |_| | (_) |  __/ |   | |_| | (_| | |  
 \\__| |\\___/ \\___|_|    \\__| |\\__,_|_|  
   _/ |                   _/ |          
  |__/                   |__/`);

Axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Axios.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status;
    if (status) console.error(status);
    if (status == 401) {
      console.warn("User is not logged in.");
      store.dispatch('auth/logout');
      const currentPath = router.currentRoute.value.fullPath;
      router.push({
        path: '/login',
        query: currentPath && currentPath !== '/login' ? { redirectUrl: currentPath } : {},
      });
    }
    // Important: always propagate the error, otherwise callers may receive `undefined`
    // and crash when accessing `response.data`.
    return Promise.reject(error);
  });

// Create vuetify instance
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'bobloader',
    themes: {
      bobloader: {
        dark: false,
        colors: {
          // Central brand color: phthalo green.
          primary: '#123524',
          'on-primary': '#ffffff',
          secondary: '#2a7f5f',
          background: '#f9f7f2',
          surface: '#ffffff',
          success: '#2e7d32',
          info: '#0277bd',
          warning: '#ed6c02',
          error: '#d32f2f',
        },
      },
    },
  },
  // Global defaults for form controls so we don't repeat props everywhere.
  defaults: {
    VTextField: {
      variant: 'outlined',
      density: 'compact',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'compact',
    },
    VAutocomplete: {
      variant: 'outlined',
      density: 'compact',
    },
    VCombobox: {
      variant: 'outlined',
      density: 'compact',
    },
  },
  icons: {
    defaultSet: 'mdi', // This ensures MDI is the default icon set
  },
});

const app = createApp(App);

app.use(store);
app.use(VueCookies);

const token = app.config.globalProperties.$cookies.get('token');
const email = app.config.globalProperties.$cookies.get('email');

if (token) {
  // Restore auth header on reload (login only sets it at runtime).
  Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  store.dispatch("auth/loadUser", new User(email ?? null, token));
}

// Install router after auth bootstrap so the initial navigation has access to cookies/header.
app.use(router);
app.use(vuetify);


app.mount('#app');
